import styled from 'styled-components';

export const DialogContainer = styled.div`
    h3 {
        color: ${props => {
            return props.theme.dark_mode ? '#fff' : '#252525';
        }} !important;
    }
`;
